import { Authorization } from "../../common/utils/authorization";

export class ALDDApis {
  constructor(private url: string, private authKeeper: Authorization) {}
  addIfFound(newObj: any, key: string, value: any, errorObj: { [key: string]: any }, required: boolean) {
    if (typeof value !== "undefined") {
      if (value !== null) {
        newObj[key] = value;
      } else {
        if (required) {
          errorObj[key] = false;
        }
      }
    } else {
      if (required) {
        errorObj[key] = false;
      }
    }
  }

  async validateOfferAndCheckSameDayEntry(args: {
    losAppId: string;
  }): Promise<{
    result?: {
      offer?: {
        losAppId?: string;
        promoCode?: string;
        product?: string;
        subProduct?: string;
        customerId?: string;
        dealerName?: string;
        dealerState?: string;
        dealerCity?: string;
        dealerAddress1?: string;
        dealerAddress2?: string;
        dealerAddress3?: string;
        dealerEmail?: string;
        dealerMobile?: string;
        dealerPinCode?: string;
        accountNo?: string;
        bankAccount?: string;
        branch?: string;
        emi?: string;
        interestRate?: string;
        loanAmt?: string;
        processingFees?: string;
        tenure?: string;
        engineNumber?: string;
        chassisNumber?: string;
        registrationNumberVehicleNumber?: string;
        existingLoanAccountNumber?: string;
        modelDescription?: string;
        manufacturer?: string;
        make?: string;
        annualFees1?: string;
        annualFees2?: string;
        annualFees3?: string;
        annualFees4?: string;
        smContact?: string;
        filler3?: string;
        documentationCharges?: string;
        collateralCharges?: string;
        isGstApplicable?: string;
        filler15?: string;
        typeOfCustomer?: string;
        employeeCustomerId?: string;
        sourceSystem?: string;
        crossSellFlag?: string;
        noOfAdvanceEmi?: string;
        lgCode?: string;
        smCode?: string;
        branchCode?: string;
        seCode?: string;
        hdfcProduct?: string;
        processingFeePer?: string;
        bankName?: string;
        bankBranchName?: string;
        model?: string;
        modelId?: string;
        avgCost?: number;
        upto36m?: string;
        M37_60?: string;
        M61_84?: string;
        nLtvCode?: string;
        motorInsurancePremAmt?: string;
        rto?: string;
        dealerInsuranceAmt?: string;
        motorInsuranceAvailed?: string;
        liLoanAmount?: string;
        liTenure?: number;
        insuranceSsiPremium?: string;
        insuranceNomineeName?: string;
        insuranceNomineeRelation?: string;
        micrCode?: string;
        accountType?: string;
        assetCost?: string;
        serviceTax?: string;
        dealers?: string;
        stampDuty?: string;
        emiStartDate?: string;
        insuranceAvailed?: string;
        pdApplicantFirstName?: string;
        pdApplicantLastName?: string;
        email?: string;
        aadharNo?: string;
        pdPanNo?: string;
        sex?: string;
        maritalStatus?: string;
        fatherFirstName?: string;
        fatherMiddleName?: string;
        fatherLastName?: string;
        residenceType?: string;
        yearsInCurrentResidence?: string;
        preferredMailingAddress?: string;
        alternateOfficeAddress1?: string;
        alternateOfficeAddress2?: string;
        alternateOfficeAddress3?: string;
        alternateOfficeCity?: string;
        alternateOfficeLandMark?: string;
        alternateOfficePinCode?: string;
        alternateOfficeState?: string;
        alternateOfficeStd?: string;
        alternateOfficePhone?: string;
        alternateOfficeEmail?: string;
        referenceFirstName?: string;
        referenceMiddleName?: string;
        referenceLastName?: string;
        referenceAddress1?: string;
        referenceAddress2?: string;
        referenceAddress3?: string;
        referenceCity?: string;
        referenceLandMark?: string;
        referencePinCode?: string;
        referenceState?: string;
        referenceStd?: string;
        referencePhone?: string;
        referenceEmail?: string;
        pdApplicantMiddleName?: string;
        pdPresentAddress1?: string;
        pdPresentCity?: string;
        pdPresentPin?: string;
        pdPresentState?: string;
        pdPresentLandMark?: string;
        edCompanyName?: string;
        edPresentAddress1?: string;
        edPresentAddress2?: string;
        edPresentAddress3?: string;
        edPresentCity?: string;
        edPresentLandMark?: string;
        edPresentPin?: string;
        edPresentState?: string;
        edPresentStd?: string;
        edPresentPhone?: string;
        leadId?: string;
      };
      lead?: {
        campaignId?: string;
        leadId?: string;
        liLoanAmount?: string;
        liTenure?: number;
        liInterestRate?: string;
        liEMI?: string;
        liPurposeLoan?: string;
        processingFees?: string;
        amountPayable?: string;
        emiEndDate?: string;
        emiStartDate?: string;
        sdType?: string;
        stampDuty?: string;
        documentationCharges?: string;
        collateralCharges?: string;
        processingFeesWST?: string;
        preEmiInterest?: string;
        serviceTax?: string;
        dealerSupplierId?: string;
        dealerLocation?: string;
        dealerDealerName?: string;
        dealerCustomerId?: string;
        dealerAccountNumber?: string;
        dealerVirtualCustomerId?: string;
        dealerVirtualAccountNumber?: string;
        dealerState?: string;
        dealerCity?: string;
        dealerAddress1?: string;
        dealerAddress2?: string;
        dealerAddress3?: string;
        dealerAddress4?: string;
        dealerZipCode?: string;
        dealerMobile?: string;
        dealerEmail?: string;
        dealerIfscCode?: string;
        dealerFlag?: string;
        mfg?: string;
        make?: string;
        avgCost?: number;
        segment?: string;
        ltv?: string;
        hub?: string;
        modelDescription?: string;
        registrationNumberVehicleNumber?: string;
        engineNumber?: string;
        chassisNumber?: string;
        existingLoanAccount?: string;
        roadTax?: string;
        roadTaxInsuranceAvailed?: boolean;
        rtoEditAmount?: string;
        step?: number;
        eMandateCount?: number;
        securityEmandateCount?: number;
        customerRating?: string;
        customerCategory?: string;
        profession?: string;
        constitution?: string;
        industry?: string;
        incomeSource?: string;
        residencyType?: string;
        accommodationCategory?: string;
        pslCategory?: string;
        assetCategory?: string;
        manufacturer?: string;
        assetType?: string;
        monthlyIncome?: string;
        accountType?: string;
        assetCost?: string;
        bankName?: string;
        bankBranchName?: string;
        educationalQualification?: string;
        existingLoanReligion?: string;
        existingLoanCaste?: string;
        ifsc?: string;
        micrCode?: string;
        beneficiaryAccountNumber?: string;
        existingAccountNumberDisbursalDate?: string;
        margin?: string;
        advanceInstallment?: string;
        frequency?: string;
        installmentPlan?: string;
        installmentMode?: string;
        disbursalDate?: string;
        firstEmiDueDate?: string;
        dueDay?: string;
        disburseTo?: string;
        firstSource?: string;
        finalSource?: string;
        channelCode?: string;
        dma?: string;
        marketingOfficer?: string;
        seCode?: string;
        teamLeader?: string;
        subSource?: string;
        finwareBranchId?: string;
        employerName?: string;
        employerType?: string;
        ltsNo?: string;
        leadGenerator?: string;
        purposeOfLoan?: string;
        instrument?: string;
        chargeOneStampDuty?: string;
        amountRequested?: string;
        interestStartDate?: string;
        scheme?: string;
        natureOfBusiness?: string;
        typeOfOffice?: string;
        typeOfIndustry?: string;
        typeOfCompany?: string;
        designation?: string;
        yearsInCurrentProfession?: string;
        totalWorkExperience?: string;
      };
      token?: string;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/validate-offer`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async saveVehicleDetails(args: {
    customerId?: string;
    leadId: string;
    promoCode: string;
    losAppId: string;
    dealerSupplierId?: string;
    step?: number;
  }): Promise<{
    result?: { error?: boolean; message?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, true);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);
      this.addIfFound(bodyParams, "dealerSupplierId", args.dealerSupplierId, errorObj, false);
      this.addIfFound(bodyParams, "step", args.step, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/save-vehicle-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async saveLoanInformation(args: {
    customerId?: string;
    leadId: string;
    promoCode: string;
    losAppId: string;
    selectedAmount: string;
    ifsc?: string;
    micrCode?: string;
    step?: number;
    motorInsuranceAvailed?: boolean;
    insuranceAvailed?: boolean;
    insuranceNomineeName?: string;
    insuranceNomineeGender?: string;
    insuranceNomineeRelation?: string;
    insuranceNomineeDob?: string;
  }): Promise<{
    result?: { error?: boolean; message?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, true);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);
      this.addIfFound(bodyParams, "selectedAmount", args.selectedAmount, errorObj, true);
      this.addIfFound(bodyParams, "ifsc", args.ifsc, errorObj, false);
      this.addIfFound(bodyParams, "micrCode", args.micrCode, errorObj, false);
      this.addIfFound(bodyParams, "step", args.step, errorObj, false);
      this.addIfFound(bodyParams, "motorInsuranceAvailed", args.motorInsuranceAvailed, errorObj, false);
      this.addIfFound(bodyParams, "insuranceAvailed", args.insuranceAvailed, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeName", args.insuranceNomineeName, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeGender", args.insuranceNomineeGender, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeRelation", args.insuranceNomineeRelation, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeDob", args.insuranceNomineeDob, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/save-loan-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async savePersonalDetails(args: {
    losAppId: string;
    customerId?: string;
    leadId: string;
    email?: string;
    promoCode: string;
    step?: number;
  }): Promise<{
    result?: { error?: boolean; message?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);
      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "email", args.email, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, true);
      this.addIfFound(bodyParams, "step", args.step, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/save-personal-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getIMPSDetails(args: {
    ifsc?: string;
    bank: string;
    branch?: string;
  }): Promise<{
    result?: {
      imps?: Array<{
        id?: string;
        check?: string;
        address?: string;
        contact?: string;
        city?: string;
        district?: string;
        state?: string;
        ifsc?: string;
        micrCode?: string;
        branch?: string;
      }>;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "ifsc", args.ifsc, errorObj, false);
      this.addIfFound(bodyParams, "bank", args.bank, errorObj, true);
      this.addIfFound(bodyParams, "branch", args.branch, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-imps-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getStampDuty(args: {
    leadId: string;
    liLoanAmount: string;
    state: string;
    city: string;
    tenure: string;
    losAppId: string;
    promoCode: string;
    insuranceAvailed?: boolean;
    motorInsuranceAvailed?: boolean;
  }): Promise<{
    result?: { stampDuty?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "liLoanAmount", args.liLoanAmount, errorObj, true);
      this.addIfFound(bodyParams, "state", args.state, errorObj, true);
      this.addIfFound(bodyParams, "city", args.city, errorObj, true);
      this.addIfFound(bodyParams, "tenure", args.tenure, errorObj, true);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, true);
      this.addIfFound(bodyParams, "insuranceAvailed", args.insuranceAvailed, errorObj, false);
      this.addIfFound(bodyParams, "motorInsuranceAvailed", args.motorInsuranceAvailed, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-stampDuty`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getIMPSDetailsById(args: {
    id?: string;
  }): Promise<{
    result?: { check?: string; address?: string; contact?: string; city?: string; district?: string; state?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "id", args.id, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-imps-details-id`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getCarDealerDetails(args: {
    suppId?: string;
  }): Promise<{
    result?: {
      address1?: string;
      address2?: string;
      address3?: string;
      city?: string;
      state?: string;
      supplierDesc?: string;
      zipCode?: string;
      location?: string;
      customerId?: string;
      accountNumber?: string;
      virtualCustomerId?: string;
      virtualAccountNumber?: string;
      ifsc?: string;
      channelName?: string;
      stateDesc?: string;
      region?: string;
      ddsa?: string;
      vCode?: string;
      Pdp?: string;
      mobile?: string;
      email?: string;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "suppId", args.suppId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-dealer-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getCarDealers(args: {
    manufacturer: string;
    city: string;
    state: string;
  }): Promise<{
    result?: {
      dealers?: Array<{
        supplierDesc?: string;
        suppId?: string;
        address1?: string;
        address2?: string;
        address3?: string;
        city?: string;
        zipCode?: string;
      }>;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "manufacturer", args.manufacturer, errorObj, true);
      this.addIfFound(bodyParams, "city", args.city, errorObj, true);
      this.addIfFound(bodyParams, "state", args.state, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-dealers`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getEmandateOptions(args: {
    bankName: string;
    losAppId: string;
  }): Promise<{
    result?: { bankNetBankingStatus?: boolean; bankDcStatus?: boolean; bankAadharStatus?: boolean; eMandateUrn?: string; secMandateUrn?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "bankName", args.bankName, errorObj, true);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-emandate-options`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async saveEmandateChannelAndCount(args: {
    losAppId?: string;
    leadId?: string;
    emandateChannel?: string;
  }): Promise<{
    result?: { error?: boolean; message?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "emandateChannel", args.emandateChannel, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/save-emandate-channel`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateEmandateResponseAndCount(args: {
    eMandateChannel?: string;
    eMandateStatus?: string;
    eMandateUrn?: string;
    eMandateRefNo?: string;
    eMandateMsgId?: string;
    leadId?: string;
    losAppId?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "eMandateChannel", args.eMandateChannel, errorObj, false);
      this.addIfFound(bodyParams, "eMandateStatus", args.eMandateStatus, errorObj, false);
      this.addIfFound(bodyParams, "eMandateUrn", args.eMandateUrn, errorObj, false);
      this.addIfFound(bodyParams, "eMandateRefNo", args.eMandateRefNo, errorObj, false);
      this.addIfFound(bodyParams, "eMandateMsgId", args.eMandateMsgId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/update-emandate-response`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateSecEmandateResponseAndCount(args: {
    eMandateSecStatus?: boolean;
    eMandateSecUrn?: string;
    eMandateSecRefNo?: string;
    eMandateSecMsgId?: string;
    leadId?: string;
    losAppId?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "eMandateSecStatus", args.eMandateSecStatus, errorObj, false);
      this.addIfFound(bodyParams, "eMandateSecUrn", args.eMandateSecUrn, errorObj, false);
      this.addIfFound(bodyParams, "eMandateSecRefNo", args.eMandateSecRefNo, errorObj, false);
      this.addIfFound(bodyParams, "eMandateSecMsgId", args.eMandateSecMsgId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/save-sec-mandate-response`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getURN(args: {
    losAppId?: string;
  }): Promise<{
    result?: { eMandateCount?: string; securityEmandateCount?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-urn`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateURN(args: {
    losAppId?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/update-urn`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getSecMandateFlag(args: {
    losAppId?: string;
    promoCode?: string;
  }): Promise<{
    result?: { eMandateSecRequired?: boolean; emandateSecAmount?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/get-sec-mandate-flag`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async checkEMICap(args: {
    losAppId?: string;
    promoCode?: string;
  }): Promise<{
    result?: { emiAmount?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/check-emi-cap`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async createTransactionAgreement(args: {
    customerId?: string;
    leadId: string;
    losAppId: string;
    promoCode: string;
    termsAndConditions?: boolean;
  }): Promise<{
    result?: { uniqueReferenceNo?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, true);
      this.addIfFound(bodyParams, "termsAndConditions", args.termsAndConditions, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/create-transaction-record`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async reloadSession(args: {
    uniqueReferenceNo: string;
  }): Promise<{
    result?: {
      campaignId?: string;
      leadId?: string;
      liLoanAmount?: string;
      losAppId?: string;
      liTenure?: number;
      liInterestRate?: string;
      liEMI?: string;
      liPurposeLoan?: string;
      processingFees?: string;
      amountPayable?: string;
      emiEndDate?: string;
      emiStartDate?: string;
      sdType?: string;
      stampDuty?: string;
      documentationCharges?: string;
      collateralCharges?: string;
      processingFeesWST?: string;
      preEmiInterest?: string;
      serviceTax?: string;
      dealerSupplierId?: string;
      dealerLocation?: string;
      dealerDealerName?: string;
      dealerCustomerId?: string;
      dealerAccountNumber?: string;
      dealerVirtualCustomerId?: string;
      dealerVirtualAccountNumber?: string;
      dealerState?: string;
      dealerCity?: string;
      dealerAddress1?: string;
      dealerAddress2?: string;
      dealerAddress3?: string;
      dealerAddress4?: string;
      dealerZipCode?: string;
      dealerMobile?: string;
      dealerEmail?: string;
      dealerIfscCode?: string;
      dealerFlag?: string;
      mfg?: string;
      make?: string;
      avgCost?: number;
      segment?: string;
      ltv?: string;
      hub?: string;
      modelDescription?: string;
      registrationNumberVehicleNumber?: string;
      engineNumber?: string;
      chassisNumber?: string;
      existingLoanAccount?: string;
      roadTax?: string;
      roadTaxInsuranceAvailed?: string;
      rtoEditAmount?: string;
      step?: number;
      eMandateCount?: number;
      securityEmandateCount?: number;
      customerRating?: string;
      customerCategory?: string;
      profession?: string;
      constitution?: string;
      industry?: string;
      incomeSource?: string;
      residencyType?: string;
      accommodationCategory?: string;
      pslCategory?: string;
      assetCategory?: string;
      manufacturer?: string;
      assetType?: string;
      monthlyIncome?: string;
      accountType?: string;
      assetCost?: string;
      bankName?: string;
      bankBranchName?: string;
      educationalQualification?: string;
      existingLoanReligion?: string;
      existingLoanCaste?: string;
      ifsc?: string;
      micrCode?: string;
      beneficiaryAccountNumber?: string;
      existingAccountNumberDisbursalDate?: string;
      margin?: string;
      advanceInstallment?: string;
      frequency?: string;
      installmentPlan?: string;
      installmentMode?: string;
      disbursalDate?: string;
      firstEmiDueDate?: string;
      dueDay?: string;
      disburseTo?: string;
      firstSource?: string;
      finalSource?: string;
      channelCode?: string;
      dma?: string;
      marketingOfficer?: string;
      seCode?: string;
      teamLeader?: string;
      subSource?: string;
      finwareBranchId?: string;
      employerName?: string;
      employerType?: string;
      ltsNo?: string;
      leadGenerator?: string;
      purposeOfLoan?: string;
      instrument?: string;
      chargeOneStampDuty?: string;
      amountRequested?: string;
      interestStartDate?: string;
      scheme?: string;
      natureOfBusiness?: string;
      typeOfOffice?: string;
      typeOfIndustry?: string;
      typeOfCompany?: string;
      designation?: string;
      yearsInCurrentProfession?: string;
      totalWorkExperience?: string;
      pdPresentMobile?: string;
      pdPresentEmail?: string;
      aadharNo?: string;
      pdFirstName?: string;
      pdLastName?: string;
      pdMiddleName?: string;
      pdPresentAddress?: string;
      pdPresentAddress2?: string;
      pdPresentAddress3?: string;
      pdCity?: string;
      pdLandmark?: string;
      pdPinCode?: string;
      pdState?: string;
      pdPanNo?: string;
      pdPresentPhone?: string;
      pdDob?: string;
      pdSex?: string;
      pdMaritalStatus?: string;
      pdIsAddressSame?: string;
      prefAddFlag?: string;
      pdPermAddress?: string;
      pdPermAddress2?: string;
      pdPermAddress3?: string;
      pdPermCity?: string;
      pdPermLandmark?: string;
      pdPermPinCode?: string;
      pdPermState?: string;
      pdPermLandlineSTD?: string;
      pdPermPhone?: string;
      pdPermMobile?: string;
      pdPermEmail?: string;
      edIndustry?: string;
      edConstitution?: string;
      edProfession?: string;
      edCompanyName?: string;
      edOfficeAddress?: string;
      edOfficeAddress2?: string;
      edOfficeAddress3?: string;
      edOfficeState?: string;
      edOfficeCity?: string;
      edOfficePinCode?: string;
      edOfficeSTD?: string;
      edOfficePhone?: string;
      edOfficeExt?: string;
      edLandmark?: string;
      edPreferredAddress?: string;
      edOfficeEmail?: string;
      pdPanNoIsValid?: string;
      ed1OfficeAddress?: string;
      ed1OfficeAddress2?: string;
      ed1OfficeAddress3?: string;
      ed1OfficeState?: string;
      ed1OfficeCity?: string;
      ed1OfficePinCode?: string;
      ed1OfficeSTD?: string;
      ed1OfficePhone?: string;
      ed1OfficeExt?: string;
      ed1Landmark?: string;
      ed1OfficeEmail?: string;
      identityProof?: string;
      residenceProof?: string;
      residenceType?: string;
      natureOfRelation?: string;
      fdMonthlySalary?: string;
      edIsAddressSame?: string;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "uniqueReferenceNo", args.uniqueReferenceNo, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/reload-session`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateTransactionStatus(args: {
    leadId?: string;
    transactionStatus?: boolean;
    errorMsg?: string;
    errorCode?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "transactionStatus", args.transactionStatus, errorObj, false);
      this.addIfFound(bodyParams, "errorMsg", args.errorMsg, errorObj, false);
      this.addIfFound(bodyParams, "errorCode", args.errorCode, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/update-transaction-status`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async finalSubmit(args: {
    leadId?: string;
    otp?: string;
    losAppId?: string;
  }): Promise<{
    result?: { loanAvailed?: boolean; inValidOTP?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "otp", args.otp, errorObj, false);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/final-submit`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async losInjection(args: {
    Mobile?: string;
    EmailID?: string;
    PdFName?: string;
    PdMName?: string;
    PdLName?: string;
    PdAddr1?: string;
    PdAddr2?: string;
    PdAddr3?: string;
    PdCity?: string;
    PdLandMark?: string;
    PdPin?: string;
    PdState?: string;
    DateofBirth?: string;
    PdPanNo?: string;
    EdCompName?: string;
    EdCompAddr1?: string;
    EdCompAddr2?: string;
    EdCompAddr3?: string;
    EdCity?: string;
    EdLandMark?: string;
    EdPin?: string;
    EdState?: string;
    EdStd?: string;
    EdPhone?: string;
    Chassis_Number?: string;
    Engine_Number?: string;
    Existing_Loan_Account_Number?: string;
    Registration_Number_Vehicle_Number?: string;
    ModelDescription?: string;
    AccountNo?: string;
    Account_Type?: string;
    MICRCODE?: string;
    BankName?: string;
    BankBranch?: string;
    CustomerID?: string;
    InterestRate?: string;
    LoanAmt?: string;
    ProcessingFees?: string;
    PromoCode?: string;
    Tenor?: string;
    Product?: string;
    Salutation?: string;
    Sex?: string;
    MaritalStatus?: string;
    LeadGenerator?: string;
    CC_eligible?: string;
    ProductEligibility_1?: string;
    ProductEligibility_2?: string;
    ProductEligibility_3?: string;
    ProductEligibility_4?: string;
    Annual_Fees_1?: string;
    Annual_Fees_2?: string;
    Annual_Fees_3?: string;
    Annual_Fees_4?: string;
    LOS_appid?: string;
    Filler1?: string;
    Filler2?: string;
    Filler3?: string;
    Filler4?: string;
    Filler5?: string;
    Filler6?: string;
    Filler7?: string;
    Filler8?: string;
    Filler9?: string;
    Filler10?: string;
    Filler11?: string;
    Filler12?: string;
    Filler13?: string;
    Filler14?: string;
    Filler15?: string;
    Source_System?: string;
    Charge1?: string;
    Charge2?: string;
    Charge3?: string;
    Charge4?: string;
    Charge5?: string;
    Charge6?: string;
    Charge7?: string;
    Charge8?: string;
    Charge9?: string;
    Charge10?: string;
    Charge11?: string;
    Charge12?: string;
    Charge13?: string;
    Charge14?: string;
    Charge15?: string;
    Charge16?: string;
    Charge17?: string;
    Charge18?: string;
    Charge19?: string;
    Charge20?: string;
    Cross_Sell_Flag?: string;
    Total_Cross_Sell_Amount?: string;
    Cross_Sell_Product_1?: string;
    Cross_Sell_Amount_1?: string;
    Cross_Sell_Product_2?: string;
    Cross_Sell_Amount_2?: string;
    Cross_Sell_Product_3?: string;
    Cross_Sell_Amount_3?: string;
    Cross_Sell_Product_4?: string;
    Cross_Sell_Amount_4?: string;
    Cross_Sell_Product_5?: string;
    Cross_Sell_Amount_5?: string;
    Installment_Mode?: string;
    No_of_Advance_EMI?: string;
    Communication_Email?: string;
    LG_Code?: string;
    SM_Code?: string;
    Branch_Code?: string;
    SE_Code?: string;
    Father_FName?: string;
    Father_MName?: string;
    Father_LName?: string;
    Residence_Type?: string;
    Years_in_current_Residence?: string;
    Alternate_Off_Address1?: string;
    Alternate_Off_Address2?: string;
    Alternate_Off_Address3?: string;
    Alternate_Off_State?: string;
    Alternate_Off_City?: string;
    Alternate_Off_Pincode?: string;
    Alternate_Off_Landmark?: string;
    Alternate_Off_STD?: string;
    Alternate_Off_Phone?: string;
    Alternate_Off_Email_ID?: string;
    Constitution?: string;
    Profession?: string;
    Nature_of_business?: string;
    Type_of_Industry?: string;
    Type_of_Company?: string;
    Type_of_Office?: string;
    Designation?: string;
    Years_in_current_profession?: string;
    Total_Work_Experience?: string;
    Preferred_Mailing_Address?: string;
    Educational_Qualification?: string;
    Customer_Religion?: string;
    Customer_Category?: string;
    Reference_FName?: string;
    Reference_MName?: string;
    Reference_LName?: string;
    Reference_Address1?: string;
    Reference_Address2?: string;
    Reference_Address3?: string;
    Reference_State?: string;
    Reference_City?: string;
    Reference_Pincode?: string;
    Reference_Landmark?: string;
    Reference_STD?: string;
    Reference_Phone?: string;
    Reference_Email_ID?: string;
    Purpose_of_Loan?: string;
    Dealer_Name?: string;
    Manufacturer?: string;
    Make?: string;
    Model?: string;
    Asset_Cost?: string;
    Dealer_State?: string;
    Dealer_City?: string;
    Dealer_Address1?: string;
    Dealer_Address2?: string;
    Dealer_Address3?: string;
    Dealer_Email?: string;
    Dealer_Mobile?: string;
    Dealer_Pincode?: string;
    Filler16?: string;
    Filler17?: string;
    Filler18?: string;
    Filler19?: string;
    Filler20?: string;
    Filler21?: string;
    Filler22?: string;
    Filler23?: string;
    Filler24?: string;
    Filler25?: string;
    Aadhar_No?: string;
    Motor_Insurance1?: string;
    Suraksha_Kavach1?: string;
    Global_Positioning_System1?: string;
    Credit_Protect1?: string;
    Motor_Insurance2?: string;
    Suraksha_Kavach2?: string;
    Global_Positioning_System2?: string;
    Credit_Protect2?: string;
    Motor_Insurance3?: string;
    Suraksha_Kavach3?: string;
    Global_Positioning_System3?: string;
    Credit_Protect3?: string;
    Motor_Insurance4?: string;
    Suraksha_Kavach4?: string;
    Global_Positioning_System4?: string;
    Credit_Protect4?: string;
    Motor_Insurance5?: string;
    Suraksha_Kavach5?: string;
    Global_Positioning_System5?: string;
    Credit_Protect5?: string;
  }): Promise<{
    result?: {
      Insert_LosMasterResponse?: {
        Insert_LosMasterResult?: {
          flag?: string;
          uniqueID?: string;
          response_time?: string;
          response_status?: string;
          error_code?: string;
          error_msg?: string;
          Filler1?: string;
          Filler2?: string;
          Filler3?: string;
        };
      };
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "Mobile", args.Mobile, errorObj, false);
      this.addIfFound(bodyParams, "EmailID", args.EmailID, errorObj, false);
      this.addIfFound(bodyParams, "PdFName", args.PdFName, errorObj, false);
      this.addIfFound(bodyParams, "PdMName", args.PdMName, errorObj, false);
      this.addIfFound(bodyParams, "PdLName", args.PdLName, errorObj, false);
      this.addIfFound(bodyParams, "PdAddr1", args.PdAddr1, errorObj, false);
      this.addIfFound(bodyParams, "PdAddr2", args.PdAddr2, errorObj, false);
      this.addIfFound(bodyParams, "PdAddr3", args.PdAddr3, errorObj, false);
      this.addIfFound(bodyParams, "PdCity", args.PdCity, errorObj, false);
      this.addIfFound(bodyParams, "PdLandMark", args.PdLandMark, errorObj, false);
      this.addIfFound(bodyParams, "PdPin", args.PdPin, errorObj, false);
      this.addIfFound(bodyParams, "PdState", args.PdState, errorObj, false);
      this.addIfFound(bodyParams, "DateofBirth", args.DateofBirth, errorObj, false);
      this.addIfFound(bodyParams, "PdPanNo", args.PdPanNo, errorObj, false);
      this.addIfFound(bodyParams, "EdCompName", args.EdCompName, errorObj, false);
      this.addIfFound(bodyParams, "EdCompAddr1", args.EdCompAddr1, errorObj, false);
      this.addIfFound(bodyParams, "EdCompAddr2", args.EdCompAddr2, errorObj, false);
      this.addIfFound(bodyParams, "EdCompAddr3", args.EdCompAddr3, errorObj, false);
      this.addIfFound(bodyParams, "EdCity", args.EdCity, errorObj, false);
      this.addIfFound(bodyParams, "EdLandMark", args.EdLandMark, errorObj, false);
      this.addIfFound(bodyParams, "EdPin", args.EdPin, errorObj, false);
      this.addIfFound(bodyParams, "EdState", args.EdState, errorObj, false);
      this.addIfFound(bodyParams, "EdStd", args.EdStd, errorObj, false);
      this.addIfFound(bodyParams, "EdPhone", args.EdPhone, errorObj, false);
      this.addIfFound(bodyParams, "Chassis_Number", args.Chassis_Number, errorObj, false);
      this.addIfFound(bodyParams, "Engine_Number", args.Engine_Number, errorObj, false);
      this.addIfFound(bodyParams, "Existing_Loan_Account_Number", args.Existing_Loan_Account_Number, errorObj, false);
      this.addIfFound(bodyParams, "Registration_Number_Vehicle_Number", args.Registration_Number_Vehicle_Number, errorObj, false);
      this.addIfFound(bodyParams, "ModelDescription", args.ModelDescription, errorObj, false);
      this.addIfFound(bodyParams, "AccountNo", args.AccountNo, errorObj, false);
      this.addIfFound(bodyParams, "Account_Type", args.Account_Type, errorObj, false);
      this.addIfFound(bodyParams, "MICRCODE", args.MICRCODE, errorObj, false);
      this.addIfFound(bodyParams, "BankName", args.BankName, errorObj, false);
      this.addIfFound(bodyParams, "BankBranch", args.BankBranch, errorObj, false);
      this.addIfFound(bodyParams, "CustomerID", args.CustomerID, errorObj, false);
      this.addIfFound(bodyParams, "InterestRate", args.InterestRate, errorObj, false);
      this.addIfFound(bodyParams, "LoanAmt", args.LoanAmt, errorObj, false);
      this.addIfFound(bodyParams, "ProcessingFees", args.ProcessingFees, errorObj, false);
      this.addIfFound(bodyParams, "PromoCode", args.PromoCode, errorObj, false);
      this.addIfFound(bodyParams, "Tenor", args.Tenor, errorObj, false);
      this.addIfFound(bodyParams, "Product", args.Product, errorObj, false);
      this.addIfFound(bodyParams, "Salutation", args.Salutation, errorObj, false);
      this.addIfFound(bodyParams, "Sex", args.Sex, errorObj, false);
      this.addIfFound(bodyParams, "MaritalStatus", args.MaritalStatus, errorObj, false);
      this.addIfFound(bodyParams, "LeadGenerator", args.LeadGenerator, errorObj, false);
      this.addIfFound(bodyParams, "CC_eligible", args.CC_eligible, errorObj, false);
      this.addIfFound(bodyParams, "ProductEligibility_1", args.ProductEligibility_1, errorObj, false);
      this.addIfFound(bodyParams, "ProductEligibility_2", args.ProductEligibility_2, errorObj, false);
      this.addIfFound(bodyParams, "ProductEligibility_3", args.ProductEligibility_3, errorObj, false);
      this.addIfFound(bodyParams, "ProductEligibility_4", args.ProductEligibility_4, errorObj, false);
      this.addIfFound(bodyParams, "Annual_Fees_1", args.Annual_Fees_1, errorObj, false);
      this.addIfFound(bodyParams, "Annual_Fees_2", args.Annual_Fees_2, errorObj, false);
      this.addIfFound(bodyParams, "Annual_Fees_3", args.Annual_Fees_3, errorObj, false);
      this.addIfFound(bodyParams, "Annual_Fees_4", args.Annual_Fees_4, errorObj, false);
      this.addIfFound(bodyParams, "LOS_appid", args.LOS_appid, errorObj, false);
      this.addIfFound(bodyParams, "Filler1", args.Filler1, errorObj, false);
      this.addIfFound(bodyParams, "Filler2", args.Filler2, errorObj, false);
      this.addIfFound(bodyParams, "Filler3", args.Filler3, errorObj, false);
      this.addIfFound(bodyParams, "Filler4", args.Filler4, errorObj, false);
      this.addIfFound(bodyParams, "Filler5", args.Filler5, errorObj, false);
      this.addIfFound(bodyParams, "Filler6", args.Filler6, errorObj, false);
      this.addIfFound(bodyParams, "Filler7", args.Filler7, errorObj, false);
      this.addIfFound(bodyParams, "Filler8", args.Filler8, errorObj, false);
      this.addIfFound(bodyParams, "Filler9", args.Filler9, errorObj, false);
      this.addIfFound(bodyParams, "Filler10", args.Filler10, errorObj, false);
      this.addIfFound(bodyParams, "Filler11", args.Filler11, errorObj, false);
      this.addIfFound(bodyParams, "Filler12", args.Filler12, errorObj, false);
      this.addIfFound(bodyParams, "Filler13", args.Filler13, errorObj, false);
      this.addIfFound(bodyParams, "Filler14", args.Filler14, errorObj, false);
      this.addIfFound(bodyParams, "Filler15", args.Filler15, errorObj, false);
      this.addIfFound(bodyParams, "Source_System", args.Source_System, errorObj, false);
      this.addIfFound(bodyParams, "Charge1", args.Charge1, errorObj, false);
      this.addIfFound(bodyParams, "Charge2", args.Charge2, errorObj, false);
      this.addIfFound(bodyParams, "Charge3", args.Charge3, errorObj, false);
      this.addIfFound(bodyParams, "Charge4", args.Charge4, errorObj, false);
      this.addIfFound(bodyParams, "Charge5", args.Charge5, errorObj, false);
      this.addIfFound(bodyParams, "Charge6", args.Charge6, errorObj, false);
      this.addIfFound(bodyParams, "Charge7", args.Charge7, errorObj, false);
      this.addIfFound(bodyParams, "Charge8", args.Charge8, errorObj, false);
      this.addIfFound(bodyParams, "Charge9", args.Charge9, errorObj, false);
      this.addIfFound(bodyParams, "Charge10", args.Charge10, errorObj, false);
      this.addIfFound(bodyParams, "Charge11", args.Charge11, errorObj, false);
      this.addIfFound(bodyParams, "Charge12", args.Charge12, errorObj, false);
      this.addIfFound(bodyParams, "Charge13", args.Charge13, errorObj, false);
      this.addIfFound(bodyParams, "Charge14", args.Charge14, errorObj, false);
      this.addIfFound(bodyParams, "Charge15", args.Charge15, errorObj, false);
      this.addIfFound(bodyParams, "Charge16", args.Charge16, errorObj, false);
      this.addIfFound(bodyParams, "Charge17", args.Charge17, errorObj, false);
      this.addIfFound(bodyParams, "Charge18", args.Charge18, errorObj, false);
      this.addIfFound(bodyParams, "Charge19", args.Charge19, errorObj, false);
      this.addIfFound(bodyParams, "Charge20", args.Charge20, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Flag", args.Cross_Sell_Flag, errorObj, false);
      this.addIfFound(bodyParams, "Total_Cross_Sell_Amount", args.Total_Cross_Sell_Amount, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Product_1", args.Cross_Sell_Product_1, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Amount_1", args.Cross_Sell_Amount_1, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Product_2", args.Cross_Sell_Product_2, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Amount_2", args.Cross_Sell_Amount_2, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Product_3", args.Cross_Sell_Product_3, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Amount_3", args.Cross_Sell_Amount_3, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Product_4", args.Cross_Sell_Product_4, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Amount_4", args.Cross_Sell_Amount_4, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Product_5", args.Cross_Sell_Product_5, errorObj, false);
      this.addIfFound(bodyParams, "Cross_Sell_Amount_5", args.Cross_Sell_Amount_5, errorObj, false);
      this.addIfFound(bodyParams, "Installment_Mode", args.Installment_Mode, errorObj, false);
      this.addIfFound(bodyParams, "No_of_Advance_EMI", args.No_of_Advance_EMI, errorObj, false);
      this.addIfFound(bodyParams, "Communication_Email", args.Communication_Email, errorObj, false);
      this.addIfFound(bodyParams, "LG_Code", args.LG_Code, errorObj, false);
      this.addIfFound(bodyParams, "SM_Code", args.SM_Code, errorObj, false);
      this.addIfFound(bodyParams, "Branch_Code", args.Branch_Code, errorObj, false);
      this.addIfFound(bodyParams, "SE_Code", args.SE_Code, errorObj, false);
      this.addIfFound(bodyParams, "Father_FName", args.Father_FName, errorObj, false);
      this.addIfFound(bodyParams, "Father_MName", args.Father_MName, errorObj, false);
      this.addIfFound(bodyParams, "Father_LName", args.Father_LName, errorObj, false);
      this.addIfFound(bodyParams, "Residence_Type", args.Residence_Type, errorObj, false);
      this.addIfFound(bodyParams, "Years_in_current_Residence", args.Years_in_current_Residence, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Address1", args.Alternate_Off_Address1, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Address2", args.Alternate_Off_Address2, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Address3", args.Alternate_Off_Address3, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_State", args.Alternate_Off_State, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_City", args.Alternate_Off_City, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Pincode", args.Alternate_Off_Pincode, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Landmark", args.Alternate_Off_Landmark, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_STD", args.Alternate_Off_STD, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Phone", args.Alternate_Off_Phone, errorObj, false);
      this.addIfFound(bodyParams, "Alternate_Off_Email_ID", args.Alternate_Off_Email_ID, errorObj, false);
      this.addIfFound(bodyParams, "Constitution", args.Constitution, errorObj, false);
      this.addIfFound(bodyParams, "Profession", args.Profession, errorObj, false);
      this.addIfFound(bodyParams, "Nature_of_business", args.Nature_of_business, errorObj, false);
      this.addIfFound(bodyParams, "Type_of_Industry", args.Type_of_Industry, errorObj, false);
      this.addIfFound(bodyParams, "Type_of_Company", args.Type_of_Company, errorObj, false);
      this.addIfFound(bodyParams, "Type_of_Office", args.Type_of_Office, errorObj, false);
      this.addIfFound(bodyParams, "Designation", args.Designation, errorObj, false);
      this.addIfFound(bodyParams, "Years_in_current_profession", args.Years_in_current_profession, errorObj, false);
      this.addIfFound(bodyParams, "Total_Work_Experience", args.Total_Work_Experience, errorObj, false);
      this.addIfFound(bodyParams, "Preferred_Mailing_Address", args.Preferred_Mailing_Address, errorObj, false);
      this.addIfFound(bodyParams, "Educational_Qualification", args.Educational_Qualification, errorObj, false);
      this.addIfFound(bodyParams, "Customer_Religion", args.Customer_Religion, errorObj, false);
      this.addIfFound(bodyParams, "Customer_Category", args.Customer_Category, errorObj, false);
      this.addIfFound(bodyParams, "Reference_FName", args.Reference_FName, errorObj, false);
      this.addIfFound(bodyParams, "Reference_MName", args.Reference_MName, errorObj, false);
      this.addIfFound(bodyParams, "Reference_LName", args.Reference_LName, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Address1", args.Reference_Address1, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Address2", args.Reference_Address2, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Address3", args.Reference_Address3, errorObj, false);
      this.addIfFound(bodyParams, "Reference_State", args.Reference_State, errorObj, false);
      this.addIfFound(bodyParams, "Reference_City", args.Reference_City, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Pincode", args.Reference_Pincode, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Landmark", args.Reference_Landmark, errorObj, false);
      this.addIfFound(bodyParams, "Reference_STD", args.Reference_STD, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Phone", args.Reference_Phone, errorObj, false);
      this.addIfFound(bodyParams, "Reference_Email_ID", args.Reference_Email_ID, errorObj, false);
      this.addIfFound(bodyParams, "Purpose_of_Loan", args.Purpose_of_Loan, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Name", args.Dealer_Name, errorObj, false);
      this.addIfFound(bodyParams, "Manufacturer", args.Manufacturer, errorObj, false);
      this.addIfFound(bodyParams, "Make", args.Make, errorObj, false);
      this.addIfFound(bodyParams, "Model", args.Model, errorObj, false);
      this.addIfFound(bodyParams, "Asset_Cost", args.Asset_Cost, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_State", args.Dealer_State, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_City", args.Dealer_City, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Address1", args.Dealer_Address1, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Address2", args.Dealer_Address2, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Address3", args.Dealer_Address3, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Email", args.Dealer_Email, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Mobile", args.Dealer_Mobile, errorObj, false);
      this.addIfFound(bodyParams, "Dealer_Pincode", args.Dealer_Pincode, errorObj, false);
      this.addIfFound(bodyParams, "Filler16", args.Filler16, errorObj, false);
      this.addIfFound(bodyParams, "Filler17", args.Filler17, errorObj, false);
      this.addIfFound(bodyParams, "Filler18", args.Filler18, errorObj, false);
      this.addIfFound(bodyParams, "Filler19", args.Filler19, errorObj, false);
      this.addIfFound(bodyParams, "Filler20", args.Filler20, errorObj, false);
      this.addIfFound(bodyParams, "Filler21", args.Filler21, errorObj, false);
      this.addIfFound(bodyParams, "Filler22", args.Filler22, errorObj, false);
      this.addIfFound(bodyParams, "Filler23", args.Filler23, errorObj, false);
      this.addIfFound(bodyParams, "Filler24", args.Filler24, errorObj, false);
      this.addIfFound(bodyParams, "Filler25", args.Filler25, errorObj, false);
      this.addIfFound(bodyParams, "Aadhar_No", args.Aadhar_No, errorObj, false);
      this.addIfFound(bodyParams, "Motor_Insurance1", args.Motor_Insurance1, errorObj, false);
      this.addIfFound(bodyParams, "Suraksha_Kavach1", args.Suraksha_Kavach1, errorObj, false);
      this.addIfFound(bodyParams, "Global_Positioning_System1", args.Global_Positioning_System1, errorObj, false);
      this.addIfFound(bodyParams, "Credit_Protect1", args.Credit_Protect1, errorObj, false);
      this.addIfFound(bodyParams, "Motor_Insurance2", args.Motor_Insurance2, errorObj, false);
      this.addIfFound(bodyParams, "Suraksha_Kavach2", args.Suraksha_Kavach2, errorObj, false);
      this.addIfFound(bodyParams, "Global_Positioning_System2", args.Global_Positioning_System2, errorObj, false);
      this.addIfFound(bodyParams, "Credit_Protect2", args.Credit_Protect2, errorObj, false);
      this.addIfFound(bodyParams, "Motor_Insurance3", args.Motor_Insurance3, errorObj, false);
      this.addIfFound(bodyParams, "Suraksha_Kavach3", args.Suraksha_Kavach3, errorObj, false);
      this.addIfFound(bodyParams, "Global_Positioning_System3", args.Global_Positioning_System3, errorObj, false);
      this.addIfFound(bodyParams, "Credit_Protect3", args.Credit_Protect3, errorObj, false);
      this.addIfFound(bodyParams, "Motor_Insurance4", args.Motor_Insurance4, errorObj, false);
      this.addIfFound(bodyParams, "Suraksha_Kavach4", args.Suraksha_Kavach4, errorObj, false);
      this.addIfFound(bodyParams, "Global_Positioning_System4", args.Global_Positioning_System4, errorObj, false);
      this.addIfFound(bodyParams, "Credit_Protect4", args.Credit_Protect4, errorObj, false);
      this.addIfFound(bodyParams, "Motor_Insurance5", args.Motor_Insurance5, errorObj, false);
      this.addIfFound(bodyParams, "Suraksha_Kavach5", args.Suraksha_Kavach5, errorObj, false);
      this.addIfFound(bodyParams, "Global_Positioning_System5", args.Global_Positioning_System5, errorObj, false);
      this.addIfFound(bodyParams, "Credit_Protect5", args.Credit_Protect5, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/aldd/los-injection`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }
}
